import { Grid } from '@mui/material';
import { HorizontalListItem } from '../Lists';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { REDUX_KEY } from '../../redux/constants';
import { setDuration } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { DURATION_SECONDS } from '../../constants';
import { TooltipBubble } from '../TooltipBubble';
import styled from 'styled-components';
import BasicGapContainer from './BasicGapContainer';
import DescriptionContainer from './DescriptionContainer';

const CampaignDurations = () => {
  const dispatch = useAppDispatch();
  const { five, ten, fifteen, thirty, fortyfive, sixty, ninety } =
    useAppSelector(
      (state: RootState) => state.detail[REDUX_KEY.CAMPAIGN_DURATIONS]
    );

  const handleChange = (durationName: string) => {
    const toggleDuration = setDuration({
      durationName
    });

    dispatch(toggleDuration);
  };

  const durations = [
    { text: '5 Second Burst', checked: five, duration: DURATION_SECONDS.FIVE },
    { text: '10 Second Burst', checked: ten, duration: DURATION_SECONDS.TEN },
    {
      text: '15 Second Burst',
      checked: fifteen,
      duration: DURATION_SECONDS.FIFTEEN
    },
    {
      text: '30 Second Burst',
      checked: thirty,
      duration: DURATION_SECONDS.THIRTY
    },
    {
      text: '45 Second Burst',
      checked: fortyfive,
      duration: DURATION_SECONDS.FORTY_FIVE
    },
    {
      text: '60 Second Burst',
      checked: sixty,
      duration: DURATION_SECONDS.SIXTY
    },
    {
      text: '90 Second Burst',
      checked: ninety,
      duration: DURATION_SECONDS.NINETY
    }
  ];

  return (
    <BasicGapContainer>
      <DescriptionContainer>
        <h3>
          Campaign Durations
          <TooltipBubble title="Campaign durations in this context denote the various lengths of advertisements, measured in seconds, used within a marketing or promotional strategy." />
        </h3>
        <p>Select all the durations for your campaign</p>
      </DescriptionContainer>

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
        {durations.map((duration, index) => (
          <Grid item xs={6} key={index}>
            <HorizontalListItem
              text={duration.text}
              checked={duration.checked}
              onChange={() => handleChange(duration.duration)}
            />
          </Grid>
        ))}
      </Grid>
    </BasicGapContainer>
  );
};

export default CampaignDurations;
